import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";

// 🧪 Passo a passo do piloto "Simular uma entrevista" (23/10/2026). Nelson: o roteiro vai por e-mail a quem quiser
// testar — o e-mail leva só o link desta página, e o post da enquete avisa que ele chega ao criar a conta de empresa.
// Tudo aqui descreve o que JÁ está no ar (SimularEntrevista.jsx / SimulacaoEndpoints.cs); se o fluxo mudar, mude aqui.
const PASSOS = [
  ["Entre com a conta da empresa", "Abra o menu Entrevistas e clique na aba “🧪 Simular uma entrevista”."],
  ["Convide um colega", "Informe o nome e o e-mail de quem vai fazer o papel de candidato e escolha “Agora” ou um horário. Dá para remarcar depois."],
  ["Cada um entra pelo seu link", "O colega recebe por e-mail o convite para a agenda e o link da sala, sem precisar criar conta. Você entra pelo botão “Entrar na sala” no próprio painel."],
  ["Libere câmera e microfone", "A sala abre 15 minutos antes do horário. Quando o navegador pedir, permita a câmera e o microfone."],
  ["Aceite o feedback da IA", "Na entrada aparece “Quer receber feedback?”. Para testar a parte da IA, os dois aceitam."],
  ["Faça a entrevista", "Conduza como se fosse real. Uns 15 minutos já bastam. No fim, clique em “Encerrar”."],
];

export default function SimulacaoGuiaPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-3xl mx-auto px-4 py-8">
        <p className="text-xs font-bold tracking-widest text-accent uppercase">Piloto</p>
        <h1 className="text-3xl font-extrabold text-text mt-1">🧪 Como testar a entrevista pelo eaiRH</h1>
        <p className="text-gray-700 mt-3">
          Faça uma entrevista de teste dentro do portal com um colega da sua empresa no papel de candidato, e vejam na
          prática o agendamento, a sala de vídeo e o feedback da IA para os dois lados.
        </p>

        <section className="bg-white rounded-2xl shadow-sm p-5 mt-6">
          <h2 className="font-bold text-text text-lg">O que você precisa</h2>
          <ul className="mt-2 space-y-1.5 text-gray-700 text-sm list-disc pl-5">
            <li>Uma conta de empresa no eaiRH. Se ainda não tem, <Link to="/entrar?tipo=empresa&cadastro=1" className="text-primary underline">crie aqui</Link> e escolha &ldquo;Sou empresa&rdquo;; a aprovação sai no mesmo dia.</li>
            <li>Um colega para fazer o papel de candidato. Ele não precisa criar conta.</li>
            <li>Computador ou celular com câmera e microfone, de preferência no Chrome ou no Edge.</li>
            <li>Uns 20 a 30 minutos.</li>
          </ul>
        </section>

        <section className="bg-white rounded-2xl shadow-sm p-5 mt-4">
          <h2 className="font-bold text-text text-lg">Passo a passo</h2>
          <ol className="mt-3 space-y-3">
            {PASSOS.map(([t, d], i) => (
              <li key={t} className="flex gap-3">
                <span className="shrink-0 w-7 h-7 rounded-full bg-primary text-white text-sm font-bold flex items-center justify-center">{i + 1}</span>
                <div><p className="font-semibold text-text">{t}</p><p className="text-sm text-gray-700">{d}</p></div>
              </li>
            ))}
          </ol>
        </section>

        <section className="bg-white rounded-2xl shadow-sm p-5 mt-4">
          <h2 className="font-bold text-text text-lg">Depois da entrevista</h2>
          <ul className="mt-2 space-y-1.5 text-gray-700 text-sm list-disc pl-5">
            <li>Cada um recebe por e-mail o próprio feedback da IA: o colega, pontos de melhoria como candidato; você, um retorno sobre a condução da entrevista.</li>
            <li>O feedback pode levar algumas horas para chegar.</li>
          </ul>
        </section>

        <section className="rounded-2xl border border-amber-200 bg-amber-50 p-5 mt-4 text-sm text-amber-900">
          <h2 className="font-bold text-base">Bom saber</h2>
          <ul className="mt-2 space-y-1.5 list-disc pl-5">
            <li>É uma simulação: não aparece para candidatos, não tem vaga envolvida e não conta na reputação da empresa.</li>
            <li>Por ser piloto, a equipe do eaiRH pode ler o feedback desta simulação para melhorar a ferramenta.</li>
            <li>Limite do piloto: 3 simulações por empresa a cada 7 dias.</li>
          </ul>
        </section>

        <p className="text-gray-700 mt-6">
          Depois de testar, conta para a gente o que funcionou, o que travou e o que faltou: responda o e-mail ou escreva
          para <a href="mailto:comercial@eairh.com.br" className="text-primary underline">comercial@eairh.com.br</a>. É isso que vai moldar a versão final.
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          <Link to="/entrevistas" className="bg-accent text-white font-bold rounded-lg px-5 py-2.5">Simular uma entrevista</Link>
          <Link to="/entrar?tipo=empresa&cadastro=1" className="border border-primary text-primary font-semibold rounded-lg px-5 py-2.5">Criar conta de empresa</Link>
        </div>
      </main>
    </div>
  );
}
